import styled from 'styled-components';

export const PadddingLeftRight16px = styled.div`
    padding: 0 16px;
`;
